
var settingApp = angular.module('settingApp', ['ui.bootstrap','configService', 'sharedServices', 'sharedFilters','ngFileUpload','ngImgCrop']);

// module.directive("compareTo", compareTo);

settingApp.config(function($interpolateProvider,config,EncryptedLocalStorageProvider) {
    config.vtoken = localStorage.getItem('vtoken');

    $interpolateProvider.startSymbol('{[');
    $interpolateProvider.endSymbol(']}');
});

settingApp.controller('settingController', ['$scope', 'config','changePassword','Upload','EncryptedLocalStorage', '$timeout','$window', '$http', function($scope, config,changePassword,Upload,EncryptedLocalStorage,$timeout,$window, $http) {
    config.vtoken = localStorage.getItem('vtoken');
    $scope.settings = {};
    $scope.settings.vendor_logo = (localStorage.getItem('catalog_brand_icon_url'))
    function logoUpload (fileData, fileContent) {
        
        var target = fileContent && fileContent.target;
        if(!target) return 
        var file = target.files && target.files.length && target.files[0];
        if(!file) return
        $('.img-loader').css('display', 'block');

        return $http({
            method: 'post',
            url: config.domain + '/node/v1/upload/image/generate-signed-urls',
            data: {
                images: [{
                    "resource_name": "catalog_top_brand_icon",
                    "resource_id": JSON.parse(localStorage.getItem('redux')).profile.profile.vendor_id,
                    "meta_data": {
                        "image_name": file.name,
                        "width": 300,
                        "height": 300,
                        "content_type": file.type
                    }
                }]
            },
            headers: {
                'Content-Type': 'application/json',
                'source': 1,
                'token': config.vtoken
              }
        }).success(function(res) {
            $('.img-loader').css('display', 'none');
            $('#cover-container-box').find('span').text('Success');
            return $http({
                method: 'put',
                url: res.data.response[0].url,
                data: Upload.dataUrltoBlob(fileData),
                headers: {
                    'Content-Type': file.type + '/base64',
                    ContentType: file.type,
                    ACL: 'public-read',
                },
            })       
        })
    }

    function readURL(input) {
        if (input.target && input.target.files && input.target.files[0]) {
            var reader = new FileReader();

            reader.onload = (function(inputField) {
                return function(event) {
                    $scope.settings.vendor_logo = event.target.result;
                
                    logoUpload(event.target.result, inputField);
                };
            })(input);
    
            reader.readAsDataURL(input.target.files[0]);
        }
    }

    document.querySelector('#imgLogo').onchange = function(ev) { readURL(ev) };
        var windowheight = $(window).height();
    var cropAreaheight = windowheight - 180;
    var modalimgheight = windowheight - 100;
    $('.cropArea').css('height', cropAreaheight + 'px');

    $('#cropModal').find('.modal-body').css('height', modalimgheight + 'px');

    $scope.S3_URL = config.S3_URL;
    $scope.submitPassword = function(settings) {
        var requirederrorCount = 0;
        $('.reqerror').css('display','none');
        $('.errorMsg').css('display','none');
        if ($('#oldpassword').val() == '') {
            $('#oldpassword').next('p').css('display', 'block');
            requirederrorCount++;
        } else {
            $('#oldpassword').next('p').css('display', 'none');
        }
        if ($('#newpassword').val() == '') {
            $('#newpassword').next('p').css('display', 'block');
            requirederrorCount++;
        } else {
            $('#newpassword').next('p').css('display', 'none');
        }
        if ($('#confirmpassword').val() == '') {
            $('#confirmpassword').next('p').css('display', 'block');
            requirederrorCount++;
        } else {
            $('#confirmpassword').next('p').css('display', 'none');
        }
        if (requirederrorCount > 0) {
            return;
        }

        if (settings.oldpassword == settings.newpassword) {
            $('.errorMsg').css('display','block');
            $scope.errorMsg = '*New Password should be different from old';
            return;
        }
        if (settings.newpassword != settings.confirmpassword) {
            $('.errorMsg').css('display','block');
            $scope.errorMsg = '*Passwords do not match';
            return;
        }
        $('#passwordForm').find('.password-save').html('');
        $('#passwordForm').find('.invite-spin').css('display', 'block');

        changePassword(config.vtoken, settings.oldpassword, settings.newpassword, settings.confirmpassword).then(function(data) {
            if (data.data.response.status) {
                settings.oldpassword = '';
                settings.newpassword = '';
                settings.confirmpassword = '';
                $scope.errorMsg = '';
                $('#passwordForm').find('.invite-spin').css('display', 'none');
                $timeout(function() {
                    $('.completeMsg').text('Password reset successfully. Kindly login again.');

                    $('#passwordForm').find('.password-save').html('Save Changes');
                    $scope.errorMsg = '';
                    localStorage.removeItem("vendor_logged_in");
                    localStorage.removeItem('vtoken');
                    $window.location.href = config.domain;
                }, 1000);
            } else {
                $('.errorMsg').css('display','block');
                $('#passwordForm').find('.invite-spin').css('display', 'none');
                $('#passwordForm').find('.password-save').html('Save Changes');
                $scope.errorMsg = '*' + data.data.response.message;
            }
        });

    };
    $scope.clearPassword = function() {
        $('.password-text-box').val('');
    };
    $('#profile-image').mouseenter(function() {
        $('.edit-button').css('display', 'block');
    });
    $('#profile-image').mouseleave(function() {
        $('.edit-button').css('display', 'none');
    })

    $('#vendor-logo').mouseenter(function() {
        $('.logo-edit-button').css('visibility', 'visible');
    });
    $('#vendor-logo').mouseleave(function() {
        $('.logo-edit-button').css('visibility', 'hidden');
    })

    $('#settingApp').on('updateSettingPic',function(event,data) {
      $scope.$apply(function() {
        $scope.settings.profile_pic = data;
      });
    });

    $('#settingApp').on('updateVendorLogo',function(event,data) {
        $scope.$apply(function() {
          $scope.settings.vendor_logo = data;
        });
      });
    $scope.loadbegin = function() {
        $('#cropModal').modal({
            backdrop: 'static',
        });
        $('#cropModal').modal('show');
    }
    $scope.logoloadbegin = function() {
        $('#logoCropModal').modal({
            backdrop: 'static',
        });
        $('#logoCropModal').modal('show');
    }
    var dataURItoBlob = function(dataURI) {
        var binary = atob(dataURI.split(',')[1]);
        var mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0];
        var array = [];
        for (var i = 0; i < binary.length; i++) {
            array.push(binary.charCodeAt(i));
        }
        return new Blob([new Uint8Array(array)], {
            type: mimeString
        });
    };
    $scope.upload = function(file) {
        $('#cropModal').modal('hide');
        Upload.upload({
            url: config.domain + '/api/v1/vendor/upload/profile_pic?version=1.1&token=' + config.vtoken,
            data: {
                vendor_profile_pic: Upload.dataUrltoBlob(file)
            },
        }).then(function(response) {
            if (response.data && response.status) {
                $scope.settings.profile_pic = response.data.data.original_pic_url;
                $('#settingApp').trigger('updateVendorPic', [$scope.settings.profile_pic]);
                $('.img-loader').css('display', 'none');
            }
        }, function(response) {
            if (response.status > 0) {
                $scope.errorMsg = response.status + ': ' + response.data;
                $('#cover-container-box').find('span').text('Try Again');
            }
        }, function(evt) {
            $('.img-loader').css('display', 'block');
        });
    }

    $scope.showPassword = function(id) {
        if ($(id).attr("type") == "password") {
          $(id).attr("type", "text");

        } else {
          $(id).attr("type", "password");
        }
    };

    $("#showHide").click(function() {
    if ($(".password").attr("type") == "password") {
      $(".password").attr("type", "text");

    } else {
      $(".password").attr("type", "password");
    }
  });
}]);
angular.bootstrap(document.getElementById("settingApp"), ['settingApp']);

